<template>
  <div>
    <Upload
      v-show="false"
      :inputClass="'editorImage' + classRandom"
      :ref="'imageUpload'+ classRandom"
      :listType="'picture-card'"
      @uploadChange="handleExceed"
    ></Upload>
    <quillEditor
      :ref="'myQuillEditor' + classRandom"
      @change="onEditorChange($event)"
      v-model="content"
      :options="editorOption"
    />
  </div>
</template>
<script>
import { quillEditor } from 'vue-quill-editor'
import { Upload } from '@/components'
import { transformUrl } from '@/utils/util'
import './css/quill.core.css'
import './css/quill.snow.css'
import './css/quill.bubble.css'
export default {
  name: 'QuillEditor',
  components: { quillEditor, Upload },
  // eslint-disable-next-line vue/require-prop-types
  props: ['content', 'toolbar'], // 父组件传过来的，将传过来的渲染到富文本编辑器
  model: {
    prop: 'content',
    event: 'change'
  },
  created() {
    // this.value = this.content
  },
  data() {
    return {
      classRandom: Math.floor(Math.random() * 10000).toString(), // 多个文本框
      uillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画
      serverUrl: '', // 上传的图片服务器地址
      editorOption: {
        // 符文本编辑器的配置
        placeholder: '',
        theme: 'snow',
        modules: {
          toolbar: {
            container: this.toolbar || [
              ['bold', 'italic', 'underline', 'strike'], // toggled buttons
              ['blockquote', 'code-block'],

              [{ header: 1 }, { header: 2 }], // custom button values
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
              [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
              [{ direction: 'rtl' }], // text direction

              [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
              [{ header: [1, 2, 3, 4, 5, 6, false] }],

              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ font: [] }],
              [{ align: [] }],
              ['link'],
              ['image'],
              ['clean'] // remove formatting button
            ],
            handlers: {
              image: value => {
                if (value) {
                  console.log('image', value)
                  // document.querySelector('#quill-upload').click()
                  this.$refs['imageUpload' + this.classRandom].uploadClick()
                } else {
                  this.$refs['myQuillEditor' + this.classRandom].format('image', false)
                }
              }
            }
          }
        }
      }
    }
  },
  methods: {
    onEditorChange({ quill, html, text }) {
      //  富文本编辑器内容发生改变的时候
      // this.value = html
      this.$emit('change', html) //  将富文本编辑器输入的文本发送给父组件，父组件涉及提交添加或者更改
    },
    beforeUpload() {
      //  上传图片之前开启loading
      this.uillUpdateImg = true
    },
    uploadError() {
      //  图片上传失败,关闭loading
      this.uillUpdateImg = false
      this.$message.error('图片插入失败')
    },
    handleExceed(response) {
      //  图片添加成功
      const quill = this.$refs['myQuillEditor' + this.classRandom].quill
      console.log(response)
      // if (response.length > 0) {
      const length = quill.selection.savedRange.index
      const image = response.length > 0 ? transformUrl(response[response.length - 1]) : ''
      if (image) {
        // 插入图片  response.data.url为服务器返回的图片地址
        quill.insertEmbed(length, 'image', image)
        // 调整光标到最后
        quill.setSelection(length + 1)
        // } else {
        //   this.$message.error('图片插入失败')
        // }
        // this.fileList = fileList
        this.uillUpdateImg = false
      }
    }
  }
}
</script>

<style scoped>
.ql-editor {
  height: 500px;
}
</style>
